jQuery(document).ready(function() {
	jQuery('.nextarticle').click(function () {
		var current = jQuery(this).parent().find('.current').text();
		var numberofposts = jQuery(this).parent().find('.numberofposts').text();
		if (current < numberofposts) {
			jQuery(this).parent().parent().parent().parent().next('.hiddenarticle').removeClass('hiddenarticle');
			jQuery(this).parent().parent().parent().parent().toggleClass('hiddenarticle');

		} else {
			jQuery(this).parent().parent().parent().parent().prev('.hiddenarticle').removeClass('hiddenarticle');
			jQuery(this).parent().parent().parent().parent().toggleClass('hiddenarticle');
		}
	})
}); 